import { Button, Tooltip } from 'slab'
import { fetchWithHeaders, getCSRFToken } from 'utils'

export default function ReceivedPaymentActions ({
  id,
  processingState,
  remoteState,
}: {
  id: string,
  processingState: string,
  remoteState: string,
}) {
  const retryable = remoteState === 'marked_for_return' && (processingState === 'failed' || processingState === 'rejected')

  return (
    <Tooltip
      content='This received payment cannot be reprocessed.'
      enabled={!retryable}
    >
      <Button
        variant='primary'
        disabled={!retryable}
        onClick={() => {
          fetchWithHeaders(`/admin/received_payments/${id}/reprocess`, {
            method: 'POST',
            headers: {
              'X-CSRF-Token': getCSRFToken() || '',
            },
          }).then(() => {
            window.location.reload()
          })
        }}
      >
        Retry Received Payment
      </Button>
    </Tooltip>
  )
}
